import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import { TooltipProps } from "@mui/material/Tooltip";

const Tooltips = ({
  message,
  children,
  placement,
  wrapperSx,
}: {
  message: string;
  children: React.ReactNode;
  placement?: TooltipProps["placement"];
  /** Merges into the wrapper Box (e.g. `{ display: "block", width: "100%" }` for full-width triggers). */
  wrapperSx?: SxProps<Theme>;
}) => {
  return (
    <Tooltip
      title={message}
      arrow
      placement={placement}
      slotProps={{
        tooltip: {
          sx: {
            maxWidth: "min(100vw, 32rem)",
            fontSize: "0.9rem",
            lineHeight: 1,
          },
        },
      }}
    >
      <Box sx={{ display: "inline-flex", alignItems: "center", ...wrapperSx }}>{children}</Box>
    </Tooltip>
  );
};

export default Tooltips;
